module.exports = __webpack_public_path__ + "static/media/DoubleLegRaise.dd671582.jpg";